// eslint-disable-next-line no-useless-escape
export const emailPattern = /^[\w.+-]+@([\w-]+\.)+[\w-]{2,}$/;